import Grid from '@blocks/Grid'
import React from 'react'
import { useSalonContext } from '../../context'
import Delivery from './components/Delivery'

export default function SalonInfo() {
    const { salon } = useSalonContext()

    if (salon.state.type !== 'finished')
        return null

    if (!salon.attrs.has.awards())
        return null

    return (
        <Grid gap="10px">
            <Grid gap="0px">
                <small>Information</small>
                <hr />
            </Grid>
            <Grid gap="30px" columns="4">
                <Grid gap="5px">
                    <h4>Delivery</h4>
                    <Delivery trackings={salon.attrs.trackings()} />
                </Grid>
            </Grid>
        </Grid>
    )
}